export class CarbonCreditsHtml {
    render() {
        return `
        <div class="container-layout d-grid grid-1">
            <div class="container-column">
                <div class="container-body">
                    <div class="d-grid grid-4 mini-card-widget" style="gap: 15px;">
                    <div class="container-column">
                        <div>Instant Avoided</div>
                        <div data-carbon="instant_kgco2">0.0</div>
                        <div>kgCO₂e/hr</div>
                    </div>
                    <div class="container-column">
                        <div>Today Avoided</div>
                        <div data-carbon="daily_tco2">0.000</div>
                        <div>tCO₂e</div>
                    </div>
                    <div class="container-column">
                        <div>This Month</div>
                        <div data-carbon="monthly_tco2">0.0</div>
                        <div>tCO₂e</div>
                    </div>
                    <div class="container-column">
                        <div>Eligible Credits (YTD)</div>
                        <div data-carbon="eligible_credits">0.0</div>
                        <div>tCO₂e</div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        
        `;
    }
}